/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-09 14:33:32
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-11 14:48:00
 */

import moment from 'moment'
import { DateTimeFormatSimple } from './datetime'

export function printBody(data: any) {
  const detail = data
  const content =
    '<div style="margin-left: 10px;margin-right: 10px">' +
    '    <h5 style="text-align: center;margin-bottom: 5px;">' +
    '首营品种审批表' +
    '</h5>' +
    '    <div style="font-size:10px;display:flex;margin-bottom:6px">' +
    '        <div style="display: flex;justify-content:flex-start;width:50%;padding-left: 10px">编号:<div style="width:70px;border-bottom: 1px solid #000;padding-left: 10px">' +
    '</div></div>' +
    '       <div style="display: flex;justify-content:flex-end;width:50%;padding-right: 10px">申报日期:<div style="display:flex;padding-left: 10px">' +
    '<div style="width:40px;border-bottom: 1px solid #000;padding-left: 10px">' +
    '</div>' +
    '<div>' +
    ' 年 ' +
    '</div>' +
    '<div style="width:20px;border-bottom: 1px solid #000;padding-left: 10px">' +
    '</div>' +
    '<div>' +
    ' 月 ' +
    '</div>' +
    '<div style="width:20px;border-bottom: 1px solid #000;padding-left: 10px">' +
    '</div>' +
    '<div>' +
    ' 日 ' +
    '</div>' +
    '</div>' +
    '</div>' +
    '    </div>' +
    '    <div style="font-size:8px;width:100%">' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            通用名' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.genericName +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            商品名' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.name +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '           商品编码' +
    '       </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;">' +
    detail?.no +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            剂型' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.doseCategory +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            规格' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.spec +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '           质量标准' +
    '       </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;">' +
    detail?.qualityStandard +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            批准文号' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.approvalNumber +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            存储条件' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.putCategory +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '           有效期' +
    '       </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;">' +
    (detail?.deadline
      ? moment(detail?.deadline).format(DateTimeFormatSimple)
      : '') +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            适应症' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;text-align:center;box-sizing: border-box">' +
    detail?.indication +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            生产企业名称' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 52%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.tenantSupplierName +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            剂量单位' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;">' +
    detail?.accountUnit +
    '        </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            生产地址' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;text-align:center;box-sizing: border-box">' +
    detail?.origin +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            含税进价' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    (detail?.stockPrice > 0 ? detail?.stockPrice : '') +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            售价' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 52%;text-align:center;box-sizing: border-box;">' +
    detail?.retailPrice +
    '        </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            供货联系人' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 20%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.contactName +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            电话' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 52%;text-align:center;box-sizing: border-box;">' +
    detail?.contactPhone +
    '        </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            质量状况' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;text-align:center;box-sizing: border-box">' +
    detail?.qualityCondition +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:14px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            采购意见' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;padding:4px 10px 0 10px;text-align:center;box-sizing: border-box">' +
    '       <div style="min-height:80px;width:100%">' +
    '         <div style="min-height:60px;width:100%;text-align:left";padding:0 20px>' +
    detail?.buyOpinion +
    '         </div>' +
    '         <div style="line-height:20px;width:100%;display:flex;justify-content:flex-end;">' +
    '          <div style="width:100px;text-align:center">' +
    '            采购人：' +
    '           </div>' +
    '           <div style="width:40px;text-align:center">' +
    (detail?.buyOpinionTime
      ? moment(detail?.buyOpinionTime).format('YYYY')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 年 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.buyOpinionTime
      ? moment(detail?.buyOpinionTime).format('MM')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 月 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.buyOpinionTime
      ? moment(detail?.buyOpinionTime).format('DD')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 日 ' +
    '           </div>' +
    '         </div>' +
    '       </div>' +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:14px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            质量审核意见' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;padding:4px 10px 0 10px;text-align:center;box-sizing: border-box">' +
    '       <div style="min-height:80px;width:100%">' +
    '         <div style="min-height:60px;width:100%;text-align:left";padding:0 20px">' +
    detail?.qualityAuditOpinion +
    '         </div>' +
    '         <div style="line-height:20px;width:100%;display:flex;justify-content:flex-end;">' +
    '          <div style="width:100px;text-align:center">' +
    '            审核人：' +
    '           </div>' +
    '           <div style="width:40px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.qualityAuditTime).format('YYYY')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 年 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.qualityAuditTime).format('MM')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 月 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.qualityAuditTime).format('DD')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 日 ' +
    '           </div>' +
    '         </div>' +
    '       </div>' +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:14px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            审批意见' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;padding:4px 10px 0 10px;text-align:center;box-sizing: border-box">' +
    '       <div style="min-height:80px;width:100%">' +
    '         <div style="min-height:60px;width:100%;text-align:left";padding:0 20px">' +
    detail?.approvalOpinion +
    '         </div>' +
    '         <div style="line-height:20px;width:100%;display:flex;justify-content:flex-end;">' +
    '          <div style="width:100px;text-align:center">' +
    '            企业负责人：' +
    '           </div>' +
    '           <div style="width:40px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.approvalOpinionTime).format('YYYY')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 年 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.approvalOpinionTime).format('MM')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 月 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.approvalOpinionTime).format('DD')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 日 ' +
    '           </div>' +
    '         </div>' +
    '       </div>' +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:14px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            备注' +
    '        </div>' +
    '       <div style="display: table-cell;word-break:break-all;width: 84%;height:60px;padding:4px 10px 0 10px;text-align:left;box-sizing: border-box">' +
    detail?.remark +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12.2%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            制表人' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 37%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.createUserName +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            日期' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 37%;text-align:center;box-sizing: border-box;">' +
    '        </div>' +
    '    </div>' +
    '    </div>'
  return content
}

export function printBodyBusiness(data: any) {
  const detail = data
  const list = [
    { name: '药品/经营许可证复印件', flag: detail?.scfyjFlag },
    { name: 'GMP/GSP证书复印件', flag: detail?.gspfyjFlag },
    { name: '营业执照复印件和年报公示', flag: detail?.yyzzfyjFlag },
    { name: '开户户名、开户银行及账号', flag: detail?.khhFlag },
    { name: '质量保证协议', flag: detail?.zlbzxyFlag },
    { name: '授权书及销售员身份证件', flag: detail?.sqsFlag },
    { name: '印章、随货同行联样式', flag: detail?.yzFlag },
    { name: '供货单位及品种相关资料', flag: detail?.gwdwFlag },
  ]?.filter((v) => v?.flag == 1)
  let content =
    '<div style="margin-left: 10px;margin-right: 10px">' +
    '    <h5 style="text-align: center;margin-bottom: 5px;">' +
    '首营企业审批表' +
    '</h5>' +
    '    <div style="font-size:10px;display:flex;margin-bottom:6px">' +
    '        <div style="display: flex;justify-content:flex-start;width:50%;padding-left: 10px">编号:<div style="width:70px;border-bottom: 1px solid #000;padding-left: 10px">' +
    '</div></div>' +
    '       <div style="display: flex;justify-content:flex-end;width:50%;padding-right: 10px">填表日期:<div style="display:flex;padding-left: 10px">' +
    '<div style="width:40px;border-bottom: 1px solid #000;padding-left: 10px">' +
    '</div>' +
    '<div>' +
    ' 年 ' +
    '</div>' +
    '<div style="width:20px;border-bottom: 1px solid #000;padding-left: 10px">' +
    '</div>' +
    '<div>' +
    ' 月 ' +
    '</div>' +
    '<div style="width:20px;border-bottom: 1px solid #000;padding-left: 10px">' +
    '</div>' +
    '<div>' +
    ' 日 ' +
    '</div>' +
    '</div>' +
    '</div>' +
    '    </div>' +
    '    <div style="font-size:8px;width:100%">' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 30%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            供货企业名称' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 30%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            类别' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 10%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '           联系电话' +
    '       </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 30%;text-align:center;box-sizing: border-box;">' +
    detail?.concatPhone +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 30%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.name +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 30%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            生产' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 10%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '           业务员' +
    '       </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 30%;text-align:center;box-sizing: border-box;">' +
    detail?.concatName +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 15%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            生产/经营许可证号' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 35%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.licenceNumber +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 10%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            有效期' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 40%;text-align:center;box-sizing: border-box">' +
    (detail?.licenceDeadline
      ? moment(detail?.licenceDeadline)?.format(DateTimeFormatSimple)
      : '') +
    '        </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 15%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            营业执照号' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 35%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.supplierTaxNo +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 10%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            有效期' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 40%;text-align:center;box-sizing: border-box">' +
    (detail?.taxDeadline
      ? moment(detail?.taxDeadline)?.format(DateTimeFormatSimple)
      : '') +
    '        </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 15%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            GMP/GSP证书号' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 35%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.gspGmpNumber +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 10%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            有效期' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 40%;text-align:center;box-sizing: border-box">' +
    (detail?.gspGmpDeadline
      ? moment(detail?.gspGmpDeadline)?.format(DateTimeFormatSimple)
      : '') +
    '        </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 15%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            生产或经营范围(以许可证为准)' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 85%;text-align:center;box-sizing: border-box">' +
    detail?.supplierRange +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 15%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            开户户名' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 85%;text-align:center;box-sizing: border-box">' +
    detail?.accountName +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 15%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            开户银行' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 25%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    detail?.bankName +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 10%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            账号' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 50%;text-align:center;box-sizing: border-box;">' +
    detail?.accountNo +
    '        </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:20px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 15%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            拟供品种' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 85%;text-align:center;box-sizing: border-box">' +
    detail?.supplierGoods +
    '       </div>' +
    '    </div>' +
    (list?.length
      ? '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:16px">'
      : '    <div style="width:100%;display:table;border:none;line-height:16px">' )+
        '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 100%;text-align:center;display:flex;flex-wrap:wrap">'
  let listContent: any = ''
  list?.map((v: any) => {
    listContent += '<div style="width: 50%">' + v?.name + '</div>'
  })
  content +=
    listContent +
    '        </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:16px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            供货企业质量保证情况' +
    '        </div>' +
    '       <div style="display: table-cell;word-break:break-all;width: 84%;;padding:0 10px;text-align:left;box-sizing: border-box">' +
    '       <div style="height:100px;width:100%">' +
    '         <div style="height:80px;width:100%">' +
    '         <div style="height:16px;width:100%">' +
    '           是否已通过政府网站核实企业资质材料的真实性？' +
    '            <span style="margin-left:20px">' +
    (detail?.zfwzFlag == 1 ? '是' : '否') +
    '            </span>' +
    '         </div>' +
    '         <div style="height:16px;width:100%">' +
    '           是否发生过质量问题、是否质量公告上被公告的？' +
    '            <span style="margin-left:20px">' +
    (detail?.zlwtFlag == 1 ? '是' : '否') +
    '            </span>' +
    '         </div>' +
    '         <div style="height:16px;width:100%">' +
    '           是否有信誉不良记录及其他不良行为？' +
    '            <span style="margin-left:20px">' +
    (detail?.blxwFlag == 1 ? '是' : '否') +
    '            </span>' +
    '         </div>' +
    '         <div style="height:16px;width:100%">' +
    '           是否需要进行实地考察？' +
    '            <span style="margin-left:20px">' +
    (detail?.sdkcFlag == 1 ? '是' : '否') +
    '            </span>' +
    '         </div>' +
    '         <div style="min-height:16px;width:100%">' +
    '           其他：' +
    '            <span style="margin-left:4px">' +
    detail?.other +
    '            </span>' +
    '         </div>' +
    '         </div>' +
    '         <div style="line-height:20px;width:100%;display:flex;justify-content:flex-end;">' +
    '          <div style="width:100px;text-align:left">' +
    '            考察人：' +
    '           </div>' +
    '           <div style="width:40px">' +
    '           </div>' +
    '           <div>' +
    ' 年 ' +
    '           </div>' +
    '           <div style="width:20px">' +
    '           </div>' +
    '           <div>' +
    ' 月 ' +
    '           </div>' +
    '           <div style="width:20px">' +
    '           </div>' +
    '           <div>' +
    ' 日 ' +
    '           </div>' +
    '         </div>' +
    '       </div>' +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:14px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            实地考察意见' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;padding:4px 10px 4px 10px;text-align:left;box-sizing: border-box">' +
    '       <div style="min-height:70px;width:100%">' +
    detail?.sdkcOpinion +
    '       </div>' +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:14px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            采购员意见' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;padding:4px 10px 0 10px;text-align:center;box-sizing: border-box">' +
    '       <div style="min-height:70px;width:100%">' +
    '         <div style="min-height:50px;width:100%;text-align:left";padding:0 20px">' +
    detail?.buyOpinion +
    '         </div>' +
    '         <div style="line-height:20px;width:100%;display:flex;justify-content:flex-end;">' +
    '          <div style="width:100px;text-align:left">' +
    '            负责人签字：' +
    '           </div>' +
    '           <div style="width:40px;text-align:center">' +
    (detail?.buyOpinionTime
      ? moment(detail?.buyOpinionTime).format('YYYY')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 年 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.buyOpinionTime
      ? moment(detail?.buyOpinionTime).format('MM')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 月 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.buyOpinionTime
      ? moment(detail?.buyOpinionTime).format('DD')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 日 ' +
    '           </div>' +
    '         </div>' +
    '       </div>' +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;border-bottom:none;line-height:14px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            质量负责人意见' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;padding:4px 10px 0 10px;text-align:center;box-sizing: border-box">' +
    '       <div style="min-height:70px;width:100%">' +
    '         <div style="min-height:50px;width:100%;text-align:left";padding:0 20px">' +
    detail?.approvalOpinion +
    '         </div>' +
    '         <div style="line-height:20px;width:100%;display:flex;justify-content:flex-end;">' +
    '          <div style="width:100px;text-align:left">' +
    '            负责人签字：' +
    '           </div>' +
    '           <div style="width:40px;text-align:center">' +
    (detail?.approvalOpinionTime
      ? moment(detail?.approvalOpinionTime).format('YYYY')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 年 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.approvalOpinionTime
      ? moment(detail?.approvalOpinionTime).format('MM')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 月 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.approvalOpinionTime
      ? moment(detail?.approvalOpinionTime).format('DD')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 日 ' +
    '           </div>' +
    '         </div>' +
    '       </div>' +
    '       </div>' +
    '    </div>' +
    '    <div style="width:100%;display:table;border: 1px solid #000;line-height:14px">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 12%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            企业负责人意见' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 84%;padding:4px 10px 0 10px;text-align:center;box-sizing: border-box">' +
    '       <div style="min-height:70px;width:100%">' +
    '         <div style="min-height:50px;width:100%;text-align:left";padding:0 20px">' +
    detail?.qualityAuditOpinion +
    '         </div>' +
    '         <div style="line-height:20px;width:100%;display:flex;justify-content:flex-end;">' +
    '          <div style="width:100px;text-align:left">' +
    '            负责人签字：' +
    '           </div>' +
    '           <div style="width:40px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.qualityAuditTime).format('YYYY')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 年 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.qualityAuditTime).format('MM')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 月 ' +
    '           </div>' +
    '           <div style="width:20px;text-align:center">' +
    (detail?.qualityAuditTime
      ? moment(detail?.qualityAuditTime).format('DD')
      : '') +
    '           </div>' +
    '           <div>' +
    ' 日 ' +
    '           </div>' +
    '         </div>' +
    '       </div>' +
    '       </div>' +
    '    </div>' +
    '    </div>'
  return content
}
